import Client from './client';

export default class DeliveredDutyOptions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getOptionsAndV2(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiences/${key}/preference/display/shipping/duty/options/v2`, options);
  }

}
